module.exports = __webpack_public_path__ + "media/images/marketing/blog2-94738e32630957b54e048f5ca750c7a620af3ddb99ea08608075c1a33de29d35.jpg";